import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import {FormGroup, FormControl, InputGroup, Glyphicon} from 'react-bootstrap';

/** Component to render an Input field */
class Input extends Component {

    static propTypes = {
        name:        PropTypes.string, // The name of the input field
        bsSize:      PropTypes.string, // The bootstrap based size
        glyph:       PropTypes.string, // The glyph to show
        type:        PropTypes.string, // The type of the input
        placeholder: PropTypes.string, // The text for the placeholder
        value:       PropTypes.string, // The value of the field
        autoFocus:   PropTypes.bool, // True when the input should be autofocusable
        onChange:    PropTypes.func, // Listener when the value has changed
        disabled:    PropTypes.bool, // True when the input should be disabled
        datacy:      PropTypes.string //
    }

    static defaultProps = {
        name:        '',
        bsSize:      'lg',
        glyph:       '',
        type:        'text',
        placeholder: '',
        value:       '',
        autoFocus:   false,
        disabled:    false
    }

    /**
     * Set this to handlers
     */
    componentWillMount() {
        this.handlerChange = this.handlerChange.bind(this);
    }

    /**
     * Focus the input when is autoFocus
     */
    componentDidMount() {
        const {autoFocus} = this.props;

        autoFocus && ReactDOM.findDOMNode(this.refs.input).focus();
    }

    /**
     * Fire the onChange event passing the value
     * @param {Event} e The event object
     */
    handlerChange(e) {
        const {onChange} = this.props;

        onChange && onChange(e.currentTarget.value);
    }

    render() {
        const {
            name,
            bsSize,
            glyph,
            type,
            value,
            placeholder,
            disabled,
            datacy
        } = this.props;

        return (
            <FormGroup bsSize={bsSize}>
                <InputGroup bsSize={bsSize}>
                    <InputGroup.Addon>
                        <Glyphicon glyph={glyph} className="fa-fw"/>
                    </InputGroup.Addon>
                    <FormControl
                        ref="input"
                        type={type}
                        name={name}
                        placeholder={placeholder}
                        value={value}
                        onChange={this.handlerChange}
                        disabled={disabled}
                        datacy={datacy}
                    />
                </InputGroup>
            </FormGroup>
        );
    }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/ui/form/Input.jsx